import { TimeWarning } from '../types/TimeWarning';
import { TimeError } from '../types/TimeError';
import { ErrorDialog } from './ErrorDialog';
import { WarningDialog } from './WarningDialog';

interface IProps {
    error: any;
}

export const TroubleDialog = ({ error: problem }: IProps) => {
    if (problem instanceof TimeError) {
        return <ErrorDialog error={problem} />;
    }
    if (problem instanceof TimeWarning) {
        return <WarningDialog warning={problem} />;
    }
    return <ErrorDialog error={{ message: problem.message, name: problem.name, pluginId: 'N/A', stackTrace: problem.stack }} />;
};
